import { render, staticRenderFns } from "./user-create-modal.vue?vue&type=template&id=10f44919&"
import script from "./user-create-modal.vue?vue&type=script&lang=ts&"
export * from "./user-create-modal.vue?vue&type=script&lang=ts&"
import style0 from "./user-create-modal.vue?vue&type=style&index=0&id=10f44919&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports